<template>
  <div
    :class="[
      $.plan_item,
      planData.name,
      isPopup ? $.popup_item : $.page_item,
      isAnnual ? $.annual : $.month,
    ]"
  >
    <div :class="$.title">
      <div
        :class="$.plan_name"
        :style="{textTransform: 'capitalize'}"
      >
        <!-- {{ locales(`${planData.name}_plan_locale`) }} -->
        {{ planData.plan_name }}
      </div>
      <div :class="$.title_chips">
        <div
          v-if="!isAnnual"
          :class="$.chip"
        >
          {{ locales('plans_annually_locale') }}
        </div>
        <div :class="$.chip">
          -30%
        </div>
      </div>
    </div>
    <div :class="$.description">
      {{ locales(`${planData.plan_title_locale}_plan_info_locale`) }}
    </div>
    <div :class="[$.price, $.action_box]">
      <div :class="$.panel">
        <div :class="$.usd">
          <span :class="$.usd__currency">$</span><span :class="[$.usd__price, $.crossed_out]">{{ priceValues.price }}</span><span :class="$.usd__price">{{ priceValues.discont }}</span><span :class="$.usd__label">USD</span>
        </div>
        <div :class="$.description">
          {{ isAnnual ? `${locales('per_user_billed_annually_locale')}` : `${locales('per_user_locale')} ${locales('per_month_key')}` }}
        </div>
      </div>
      <div
        v-if="!isPopup || isTrial"
        :class="[$.btn, $.upgrade_btn]"
        @click="demoClick"
      >
        {{ buttonText }}
      </div>
      <div
        v-else-if="isPopup && !planData.isCurrentPaymentPlan"
        :class="[$.btn, $.upgrade_btn]"
        @click="demoClick"
      >
        {{ buttonText }}
      </div>
      <div
        v-else-if="isPopup && planData.isCurrentPaymentPlan"
        :class="[$.current_plan_sticker, planData.name]"
      >
        <webix-ui
          :class="$.plan_check_icon"
          :config="icons.check"
        />
        <div :class="$.sticker_text">
          {{ locales('current_plan') }}
        </div>
      </div>
    </div>
    <div
      :class="$.plan_features"
      :style="{height: `${heights.featuresSection}px`}"
    >
      <!-- <div
        ref="featuresDesc"
        :class="$.features_desc"
        v-html="locales(`${planData.plan_title_locale}_features_list_description`)"
      /> -->
      <div
        ref="featuresDesc"
        :class="$.features_desc"
        v-html="getPlanFeaturesListTitle(planData)"
      />
      <ul
        ref="featuresList"
        :class="$.features_list"
      >
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_1`) }}
        </li>
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_2`) }}
        </li>
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_3`) }}
        </li>
        <li :class="$.item">
          {{ locales(`${planData.plan_title_locale}_feature_4`) }}
        </li>
      </ul>
    </div>
    <a
      :class="[$.about_plan_link, $.link]"
      :href="isPopup === true ? locales(`about_plan_href_${planData.plan_title_locale}`) : '#features'"
      :target="isPopup === true ? '_blank' : null"
      @click="linkClick(planData.plan_name)"
    >
      <!-- <template v-if="isPopup === true">
        {{ locales(`about_link_${planData.plan_title_locale}`) }}
      </template> -->
      <template>
        {{ locales(`about_link_compare`) }}
      </template>
      <svg
        width="20"
        height="11"
        viewBox="0 0 20 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.25 0.75L18.75 5.25M18.75 5.25L14.25 9.75M18.75 5.25H0.75"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

    </a>
    <div :class="$.bottom_bg">
      <img
        :class="$.img"
        :src="'https://cdn.ganttpro.com/app/imgs/pricing/BF_card_background.png'"
      >
      <div :class="$.bg" />
    </div>
  </div>
</template>

<script>
import svgIconForVue from '../../../common/svgIconForVue';
import bublesIcon from '../../../../svg/pricing/pricing_bubles_ic.svg';
import arrowLeft from '../../../../svg/pricing/ic_arrow_left.svg';
import peopleIcon from '../../../../svg/pricing/pricing_people_ic.svg';
import lockIcon from '../../../../svg/ic_lock.svg';
import check from '../../../../svg/pricing/check_current_plan_price.svg';
import app from '../../../../app';
import plansModel from '../../../../models/plans';

export default {
  props: {
    planData: { type: Object, required: true, default: () => {} },
    isPopup: { type: Boolean, required: true, default: false },
    heights: { type: Object, required: true, default: () => {} },
    isAnnual: { type: Boolean, required: true, default: false },
    selectedUsers: { type: Object, required: true, default: () => {} },
  },
  emits: {
    buyPlanClick: Object,
    upgradePlanClick: Object,
    togglePeriod: null,
  },
  data() {
    return {
      locales: __,
      userCount: 1,
      icons: {
        bublesIcon: svgIconForVue(bublesIcon, 62, 49),
        arrowLeft: svgIconForVue(arrowLeft, 27, 16),
        peopleIcon: svgIconForVue(peopleIcon, 24, 24),
        lockIcon: svgIconForVue(lockIcon, 24, 24),
        check: svgIconForVue(check, 20, 20),
      },
    };
  },
  computed: {
    isTrial() {
      return plansModel.isTrial();
    },
    priceValues() {
      if (this.selectedUsers.count < 20) {
        return {
          price: 35,
          discont: 25,
        };
      }

      return {
        price: 30,
        discont: 20,
      };
    },
    buttonText() {
      if (this.isAnnual) {
        return this.locales('bf_get_deal_enterprise_btn');
      }

      return this.locales('pricing_plans_switch_annual');
    },
  },
  methods: {
    getPlanFeaturesListTitle(planData) {
      let planName;

      if (planData && 'plan_id' in planData && 'plan_name' in planData) {
        if (planData.plan_id === 14) {
          return __('payment_plan_card_base_features_list_title');
        }

        if (planData.plan_id === 15) {
          planName = 'Core';
        }

        if (planData.plan_id === 16) {
          planName = 'Advanced';
        }

        if (planData.plan_id === 18) {
          planName = 'Business';
        }

        return __('payment_plan_card_features_list_title_by_plan_name', { planName });
      }

      return __(`${planData.plan_title_locale}_features_list_description`);
    },
    buyPlanClick(plan) {
      this.$emit('buyPlanClick', plan);
    },
    async upgradePlanClick(plan) {
      this.$emit('upgradePlanClick', plan);
    },
    demoClick() {
      const planName = this.planData.name;

      if (!this.isAnnual) {
        this.$emit('togglePeriod');

        return;
      }
      // app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form', planName);
      app.trigger('messageUsForm:show', 'black-friday-contact-us-form', planName);
    },
    linkClick(plan) {
      userExtAnalytics.log('pricing_learn_more_clicked', { type: plan });
    },
  },
};
</script>

<style module="$" lang="less">
@import '../../../../less/_mixins.less';
@import '../../../../less/_fonts.less';
@import '../../../../less/_variables.less';

@textColor: #fff;

.btn {
  width: 100%;
  text-align: center;
  .FontLatoBold;
  .fs(14px, 24px);
  background-color: #fff;
  border-radius: 4px;
  color: #1565C0;
  padding: 4px 0;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: #1565C0;
    background-color: #F1F5FB;
  }

  // &:active{
  //   color: #1565C0;
  //   background-color: #0D3D73;
  // }
}

.plan_item {
  // width: 252.5px;
  // min-width: 252px;
  // border: 1px solid transparent;
  border-radius: 8px;
  padding: 16px;
  margin-right: 16px;
  min-height: 476px;

  min-width: calc(25% - 16px);
  width: calc(25% - 16px);

  position: relative;
  overflow: hidden;

  &.annual {
    background: #212121;
  }

  &.month {
    background: #7a7a7a;
  }

  &:last-child {
    margin-right: 0;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .plan_name {
      .FontLatoBlack;
      .fs(20px, 30px);
      color: #fff;
    }

    .people_tooltip {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 0 3px;
      cursor: pointer;

      .count {
        .FontLatoRegular;
        .fs(16px, 30px);
        color: #666666;
        padding-left: 6px;
      }

      &:hover {
        .count {
          color: #1565C0;
        }
      }
    }

    .base_plan_tooltip {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      cursor: pointer;

      &:hover {
        background-color: #eee;
        border-radius: 1px;
      }
    }
  }

  .description {
    .FontLatoRegular;
    .fs(12px, 18px);
    color: fade(#fff, 80%);
  }

  .title ~ .description {
    margin-bottom: 16px;
    min-height:72px;
  }

  .action_box {
    margin-bottom: 16px;
    .user-count-margin {
      margin-bottom: 0;
    }

    .panel {
      // min-height: 90px;
      height: 50px;
    }
  }

  .price {
    .panel {
      // min-height: 85px;
      margin-bottom: 36px;
      .usd {
        color: #fff;

        &__currency {
          .FontLatoRegular;
          font-size: 20px;
          line-height: 1;
          vertical-align: top
        }

        &__price {
          .FontLatoBlack;
          font-size: 32px;
          line-height: 38px;
          padding: 0 4px 0 2px;

          &.crossed_out {
            .FontLatoRegular;
            color: #879290;
            position: relative;

            &::after {
              position: absolute;
              top: 60%;
              left: 0;
              width: 100%;
              height: 1px;
              background: #879290;
              content: '',
            }
          }
        }

        &__label {
          .FontLatoRegular;
          .fs(20px, 38px);
        }

        &.gray {
          color: #757575;
        }
      }
    }
  }

  .demo {
    .panel {
      // min-height: 85px;
      // margin-bottom: 16px;
      height: 50px;
      margin-bottom: 36px;
      .icon {
        margin-bottom: 10px;
      }

      .demo_title {
        .FontLatoBlack;
        .fs(24px, 28.8px);
        color: #191919;
        margin-bottom: 5px;
      }
    }
  }

  .plan_features {
    position: relative;
    z-index: 3;
    .FontLatoRegular;
    .fs(12px, 20px);
    color:#666666;
    margin-bottom: 24px;

    .features_desc {
      margin-bottom: 12px;
      .FontLatoRegular;
      .fs(12px, 21px);
      color:#fff;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .features_list {
      padding-left: 0 !important;

      .item {
        position: relative;
        margin-bottom: 5px;
        display:flex;
        gap:8px;
        color: fade(#fff, 80%);

        &::before {
          content: '';
          position: relative;
          display:block;
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_659_5053)'%3E%3Crect width='20' height='20' rx='10' fill='%231565C0'/%3E%3Cpath d='M6.66602 10.4167L8.95063 13.0154C9.09306 13.1774 9.34953 13.1635 9.47363 12.9871L13.3327 7.5' stroke='white' stroke-width='1.25' stroke-linecap='round'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_659_5053'%3E%3Crect width='20' height='20' rx='6.66667' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
          min-width:20px;
          min-height: 20px;
        }
      }
    }
  }

  .locked_view {
    position: absolute;
    bottom: -7px;
    left: 50%;
    transform: translateX(-50%);
    height: 52px;
    width: calc(100% + 16px);
    display: flex;
    align-items: center;
    background-color: #eee;
    border-radius: 2px;
    padding: 0 8px;

    .lock_desc {
      .FontLatoRegular;
      .fs(14px, 20px);
      color: @textColor;
      padding-left: 10px;
    }
  }

  .about_plan_link {
    position: relative;
    z-index: 3;
    display: flex;
    align-items: flex-start;
    height: 20px;
    gap:8px;
    &:hover {
      gap:12px;
    }
    &.link {
      .FontLatoBold;
      .fs(12px, 16px);
      color: #fff;
      text-decoration: none;
      white-space: nowrap;
      border-bottom: 1px solid transparent;

    }
    & svg {
      min-width: 20px;
      margin-top:2px;
    }
  }

  .current_plan_sticker {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .FontLatoBold;
    .fs(14px, 24px);
    border-radius: 4px;
    color: #232323;
    padding: 4px 0;
    cursor: pointer;
    background-color: #F1F5FB;

    .sticker_text {
      padding-left: 4px;
      cursor: default;
    }
  }

  &.page_item {
    min-width: calc(25% - 16px);
    width: calc(25% - 16px);
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }

    .title {
      .plan-name {
        .FontLatoBlack;
        .fs(20px, 30px);
        color: @titleHeadColor;
      }
    }

    .about_plan_link {
      a {
        color: #424242 !important;
      }
    }
  }
}

.title_chips {
  display: flex;
  align-items: center;

  .chip {
    padding: 4px 8px;
    border-radius: 24px;
    color: #fff;
    .FontLatoRegular;
    .fs(12px, 16px);
    background: #1565C0;
  }
}

.bottom_bg {
  position: absolute;
  bottom: 0;
  left: 0;

  .img {
    z-index: 2;
    position: relative;
    width: 294px;
    height: 137px;
    margin-bottom: -10px;
    margin-left: -40px;
  }

  .bg {
    position: absolute;
    bottom: -30px;
    left: -40px;
    background: #1565C0;
    filter: blur(30px);
    height: 100px;
    width: 130%;
  }
}
</style>
<style lang="less">
.people-tooltip {
  .webix_view {
    cursor: pointer;
  }
}

.current-plan-sticker {
  .webix_view {
    .webix_template {
      svg {
        path {
          fill: #232323
        }
      }
    }
  }
}
</style>
